import {
  NOT_LINKED_ITEMS_SET_LOADING,
  NOT_LINKED_DIRS_LOAD_DATA,
  NOT_LINKED_EMAILS_LOAD_DATA,
  NOT_LINKED_ITEMS_LOAD_DICTIONARIES,
  NOT_LINKED_EMAILS_LOAD_EMAIL,
} from './actions';

const initialState = {
  notLinkedDirs: [],
  notLinkedEmails: [],
  associatedEmailsWithDirs: [], // New field for associated emails with directories
  nextFilename: null, // For dirs pagination
  nextMessageId: null, // For emails pagination
  csUserList: [], // For filters
  clientList: [], // For filters
  csUserLeaderboard: [], // For filters
  currentEmailItem: null, // For storing current email data
  loaders: {
  },
};

export default function notLinkedItemsReducer(state = initialState, action) {
  switch (action.type) {
    case NOT_LINKED_ITEMS_SET_LOADING: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          [action.name]: action.loading
        }
      };
    }
    case NOT_LINKED_DIRS_LOAD_DATA: {
      if (action.loadNext) {
        return {
          ...state,
          notLinkedDirs: [...state.notLinkedDirs, ...action.items],
          nextFilename: action.nextFilename,
          associatedEmailsWithDirs: [...state.associatedEmailsWithDirs, ...action.associatedEmailsWithDirs],
        };
      }

      return {
        ...state,
        notLinkedDirs: action.items || [],
        nextFilename: action.nextFilename,
        associatedEmailsWithDirs: action.associatedEmailsWithDirs,
      };
    }
    case NOT_LINKED_EMAILS_LOAD_DATA: {
      if (action.loadNext) {
        return {
          ...state,
          notLinkedEmails: [...state.notLinkedEmails, ...action.items],
          nextMessageId: action.nextMessageId,
        };
      }

      return {
        ...state,
        notLinkedEmails: action.items || [],
        nextMessageId: action.nextMessageId,
      };
    }
    case NOT_LINKED_ITEMS_LOAD_DICTIONARIES: {
      return {
        ...state,
        csUserList: action.csUserList,
        clientList: action.clientList,
        tagsFilterList: action.tagsFilterList,
        csUserLeaderboard: action.csUserLeaderboard,
      };
    }
    case NOT_LINKED_EMAILS_LOAD_EMAIL: {
      return {
        ...state,
        currentEmailItem: action.emailData,
      };
    }

    default:
      return state;
  }
}
